
export default {
  name: 'Pagination',
  props: {
    pageInfo: {
      type: Object,
      required: true,
    },
  },
  head() {
    return {
      link: this.paginationLinks,
    }
  },
  computed: {
    paginationLinks() {
      const nextUrl = {
        rel: 'next',
        href:
          this.pageInfo.endCursor && this.pageInfo.hasNextPage
            ? `${process.env.NUXT_ENV_BASE_URL}${this.$route.path}?next=${this.pageInfo.endCursor}`
            : undefined,
      }
      const previousUrl = {
        rel: 'prev',
        href:
          this.pageInfo.startCursor && this.pageInfo.hasPreviousPage
            ? `${process.env.NUXT_ENV_BASE_URL}${this.$route.path}?prev=${this.pageInfo.startCursor}`
            : undefined,
      }

      return [nextUrl, previousUrl].filter(({ href }) => !!href)
    },
  },
}
